// services/everpro/everpro-shipping/rates/fallback.ts — 404 sub-district name resolution retry
import { everproFetch } from '../../everpro-auth';
import type { EverproRatesData } from '../../everpro-types';
import { resolveSubDistrictName } from '../../everpro-location';

export async function tryResolveNotFound(
  apiMessage: string,
  status: number,
  body: Record<string, any>,
  brandId: string,
  hints: { destSubDistrict?: string; destDistrict?: string; destCity?: string; originSubDistrict?: string } = {}
): Promise<EverproRatesData | null> {
  if (status !== 404 || !apiMessage) return null;

  let resolved = false;
  if (apiMessage.includes('origin is not found')) {
    const name = body.origin_sub_district_name || hints.originSubDistrict
      || await resolveSubDistrictName(body.origin_postal_code, brandId);
    if (name && name !== body.origin_sub_district_name) {
      body.origin_sub_district_name = name;
      resolved = true;
      console.log(`[Everpro] Fallback-resolved origin sub_district_name: "${name}"`);
    }
  }
  if (apiMessage.includes('destination is not found')) {
    // Prioritas: nama desa dari alamat (kasus 22810: kode pos tak dikenal Everpro
    // sehingga lookup-by-postal gagal, tapi nama desa "Hilihao" bisa match).
    const name = body.destination_sub_district_name || hints.destSubDistrict
      || await resolveSubDistrictName(body.destination_postal_code, brandId);
    if (name && name !== body.destination_sub_district_name) {
      body.destination_sub_district_name = name;
      resolved = true;
      console.log(`[Everpro] Fallback-resolved destination sub_district_name: "${name}"`);
    }
  }
  if (!resolved) {
    // STRIP (2026-10-04, kasus 27562/Guguak): nama kelurahan yang sudah ada di
    // body justru meracuni request — buang, coba kode-pos saja (terbukti lolos).
    if (/is not found/.test(apiMessage)
      && (body.destination_sub_district_name || body.origin_sub_district_name)) {
      delete body.destination_sub_district_name;
      delete body.origin_sub_district_name;
      resolved = true;
      console.log('[Everpro] Fallback-strip sub_district_name (coba kode-pos saja)');
    } else {
      return null;
    }
  }

  const retryRes = await everproFetch(brandId, '/shipment/v2/rates', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (retryRes.ok) {
    const retryJson = await retryRes.json();
    return (retryJson?.data ?? {}) as EverproRatesData;
  }
  const retryDetail = await retryRes.text().catch(() => '');
  let retryMessage = '';
  try { retryMessage = JSON.parse(retryDetail).message || ''; } catch { /* */ }
  if (retryMessage) throw new Error(`Everpro rates: ${retryMessage}`);
  throw new Error(`Everpro rates: ${retryRes.status} ${retryRes.statusText}`);
}
